import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { getThemeTokens } from '../../../theme/tokens';
import {
  EntityDependencyList,
  summarizeDependencyItems,
} from './EntityDependencyList';
import { EntityPanelFrame } from './EntityPanelFrame';
import { useEntityPageModel } from './useEntityPageModel';

export const EntityDependenciesPanel = () => {
  const tokens = getThemeTokens(useTheme());
  const model = useEntityPageModel();
  const items = summarizeDependencyItems([
    ...model.dependencies.upstream,
    ...model.dependencies.downstream,
  ]).slice(0, 6);

  return (
    <EntityPanelFrame title="Dependencies">
      {items.length ? (
        <EntityDependencyList items={items} />
      ) : (
        <Typography
          sx={{
            color: tokens.textMuted,
            fontSize: 14,
            lineHeight: 1.7,
          }}
        >
          No dependency relationships are currently registered for this entity.
        </Typography>
      )}
    </EntityPanelFrame>
  );
};
